import { render, staticRenderFns } from "./MessagePopup.vue?vue&type=template&id=89e5ba70&scoped=true&"
import script from "./MessagePopup.vue?vue&type=script&lang=js&"
export * from "./MessagePopup.vue?vue&type=script&lang=js&"
import style0 from "./MessagePopup.vue?vue&type=style&index=0&id=89e5ba70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e5ba70",
  null
  
)

export default component.exports